import type { IOrganizationIntegrationPepperAssetFinance } from './OrganizationIntegrationPepperAssetFinance.interface';

export default class OrganizationIntegrationPepperAssetFinance
  implements IOrganizationIntegrationPepperAssetFinance {
  merchantId: string;
  enabled: boolean;

  isEnabled() {
    return this.enabled;
  }

  static build = (data: IOrganizationIntegrationPepperAssetFinance) =>
    new OrganizationIntegrationPepperAssetFinance(data);

  static blank = () => new OrganizationIntegrationPepperAssetFinance();

  /**
   * Constructor
   * @param {IOrganizationIntegrationPepperAssetFinance} data
   */
  constructor(data?: IOrganizationIntegrationPepperAssetFinance) {
    this.merchantId = data?.merchantId || undefined;
    this.enabled = data?.enabled === true;
  }
}
